import {
  getLeoUuid,
  LeoUUID,
  getObject,
} from "@surya-digital/leo-ts-types";
import { UserName, UserNameDTO } from "./userName";
import { KeycloakEmail, KeycloakEmailDTO } from "./keycloakEmail";

export interface SpocUserDetailsDTO {
  spocId: string;
  userName: UserNameDTO;
  emailId: KeycloakEmailDTO;
}

export class SpocUserDetails {
  readonly isSpocUserDetailsSpocUserDetails: boolean = true;

  readonly spocId: LeoUUID;
  readonly userName: UserName;
  readonly emailId: KeycloakEmail;


  constructor(
  spocId: LeoUUID, 
  userName: UserName, 
  emailId: KeycloakEmail
  ) {
    this.spocId = spocId;
    this.userName = userName;
    this.emailId = emailId;
  }

  static fromDTO(dto: SpocUserDetailsDTO): SpocUserDetails {
    const spocId = getLeoUuid(dto, "spocId", InvalidSpocUserDetailsSpocIdError);
    const userName = UserName.fromDTO(getObject(dto, "userName", InvalidSpocUserDetailsUserNameError));
    const emailId = KeycloakEmail.fromDTO(getObject(dto, "emailId", InvalidSpocUserDetailsEmailIdError));
    return new SpocUserDetails(
      spocId,
      userName,
      emailId
    );
  }

  toDTO(): SpocUserDetailsDTO {
    const dto: SpocUserDetailsDTO = {
        spocId: this.spocId.toDTO(),
        userName: this.userName.toDTO(),
        emailId: this.emailId.toDTO()
    };
    return dto;
  }
  }

SpocUserDetails.prototype.toString = function toString(): string {
  return `SpocUserDetails(spocId='${this.spocId}',userName='${this.userName}',emailId='${this.emailId}')`;
};

export class InvalidSpocUserDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocUserDetailsError";
  }
}
export class InvalidSpocUserDetailsSpocIdError extends InvalidSpocUserDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocUserDetailsSpocIdError";
  }
}

export class InvalidSpocUserDetailsUserNameError extends InvalidSpocUserDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocUserDetailsUserNameError";
  }
}

export class InvalidSpocUserDetailsEmailIdError extends InvalidSpocUserDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocUserDetailsEmailIdError";
  }
}
